/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Stack, Heading, Divider } from '@towersystems/towersystems-design-system';
import page from 'page';

//import ReactJson from 'react-json-view';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import { requestConnection } from 'state/connections/actions';
import Navigation from 'modules/dashboard/connections/navigation';
import Button from 'components/button';
import { errorNotice, successNotice } from 'state/notices/actions';
import LoadingPlaceholder from 'modules/dashboard/connections/loading-placeholder';
import { DEFAULT_JSON } from './constants';
import { getCurrentUsername } from 'state/current-user/selectors';

const TestMain = ({ connectionId, username, ...props }) => {
    const [requesting, setRequesting] = useState(true);
    const [connection, setConnection] = useState(null);
    const [jsonObj, setJsonObj] = useState(DEFAULT_JSON);

    useEffect(() => {
        loadData(connectionId);
    }, []);

    const loadData = async (connectionId) => {
        setRequesting(true);
        try {
            let connections = await props.requestConnection(connectionId);
            setConnection(connections);

        } catch (error) {
            console.log('error', error);
            page('/');
        }
        setRequesting(false);
    };

    const sendData = async () => {

        try {
            if (JSON.parse(jsonObj)) {}
        } catch ( error ) {
            props.errorNotice("Invalid JSON. Please check your input data.");
            return;
        }

        try {
            await fetch('https://ecc-dev.towersystems.com.au/api/weblink/receive-master-file', {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'X-Weblink-Authorization': '123',
                    'X-Talink-Username': username,
                    'X-Talink-UserID': username,
                    'X-Group-Number': connection.group_code,
                },
                body: jsonObj
            });
            props.successNotice('Data sent succesfully.');
        } catch (e) {
            console.log(e);
        }
    };

    if (true === requesting) {
        return <LoadingPlaceholder connectionId={connectionId} section='testing' />;
    }

    return (
        <Main>
            <Navigation connectionId={connectionId} section='testing' />
            <Box paddingTop='xxlarge' paddingBottom='xxlarge'>
                <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                    <Heading level='1'>Test send data</Heading>
                    <Button onClick={sendData}>Send Data</Button>
                </Box>
                <Divider />
            </Box>
            <Stack space='medium'>
                <textarea
                    onChange={(e) => {
                        console.log(e.target.value);
                        setJsonObj(e.target.value);
                    }}
                    style={{ height: 1000 }}
                    value={jsonObj}
                ></textarea>
            </Stack>
        </Main>
    );
};

export default connect((state) => ({
    username: getCurrentUsername(state)
}), {
    requestConnection,
    errorNotice,
    successNotice,
})(TestMain);
